import w from "@arcgis/core/layers/FeatureLayer";
import g from "@arcgis/core/Graphic";
import Y from "@arcgis/core/request";
import { createLogger as W } from "@origo/logger";
import Z from "@arcgis/core/geometry/Point";
import X from "@arcgis/core/geometry/Polygon";
import { z as p } from "zod";
import { jsx as ee } from "react/jsx-runtime";
import { createContext as ne, useContext as U } from "react";
import { useQuery as k, useQueryClient as y, useMutation as b } from "@tanstack/react-query";
class A extends Error {
  constructor(n, r) {
    super(n, r), this.name = "PlanregisterError";
  }
}
class I extends A {
  constructor(n, r) {
    super(`${n} not found: ${r}`), this.name = "NotFoundError";
  }
}
class B extends A {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "ValidationError";
  }
}
class j extends A {
  constructor(n, r) {
    super(n, { cause: r }), this.name = "NetworkError";
  }
}
class re extends A {
  constructor(n = "Unauthorized") {
    super(n), this.name = "AuthError";
  }
}
class J extends A {
  constructor() {
    super("Operation was aborted"), this.name = "AbortedError";
  }
}
const M = "1";
function _(e) {
  return e.trim().padStart(4, "0");
}
function Q(e, n) {
  return `${_(e)}_${n.trim()}`;
}
const G = [
  "plantype",
  "planstatus",
  "lovreferanse",
  "forslagsstillerType"
];
function te(e, n, r) {
  return r == null || r === "" ? "" : e?.[n]?.find((l) => l.code === r)?.label ?? r;
}
function ae(e, n) {
  return e?.[n] ?? [];
}
const V = [
  "planbehandlingtype"
], Cn = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  AbortedError: J,
  AuthError: re,
  CODELIST_FIELDS: G,
  DEFAULT_PLANSTATUS: M,
  NetworkError: j,
  NotFoundError: I,
  PLANBEHANDLING_CODELIST_FIELDS: V,
  PlanregisterError: A,
  ValidationError: B,
  deriveNasjonalArealplanId: Q,
  domainLabel: te,
  domainOptions: ae,
  normalizeAdmomrkode: _
}, Symbol.toStringTag, { value: "Module" }));
function E(e) {
  if (e != null)
    return new Date(e);
}
function T(e) {
  return !!e;
}
function oe(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer ?? "",
    saksaar: e.saksaar,
    sakssekvensnr: e.sakssekvensnr,
    forslagsstillerType: e.forslagsstillerType,
    ubehandletKlage: T(e.ubehandletKlage),
    ubehandletInnsigelse: T(e.ubehandletInnsigelse),
    vedtaksdato: E(e.vedtaksdato),
    vedtakEndeligPlanDato: E(e.vedtakEndeligPlanDato),
    ikrafttredelsesdato: E(e.ikrafttredelsesdato),
    kunngjoringsdato: E(e.kunngjoringsdato),
    opprinneligAdmomrKode: e.opprinneligAdmomrKode,
    opprinneligPlanId: e.opprinneligPlanId,
    planbestemmelser: T(e.planbestemmelser)
  };
}
function R(e) {
  return {
    nasjonalArealplanId: e.nasjonalArealplanId,
    admomrkode: e.admomrkode,
    planId: e.planId,
    plannavn: e.plannavn,
    plantype: e.plantype,
    planstatus: e.planstatus,
    lovreferanse: e.lovreferanse,
    saksnummer: e.saksnummer,
    saksaar: e.saksaar ?? null,
    sakssekvensnr: e.sakssekvensnr ?? null,
    forslagsstillerType: e.forslagsstillerType ?? null,
    ubehandletKlage: e.ubehandletKlage ? 1 : 0,
    ubehandletInnsigelse: e.ubehandletInnsigelse ? 1 : 0,
    vedtaksdato: e.vedtaksdato?.getTime() ?? null,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    ikrafttredelsesdato: e.ikrafttredelsesdato?.getTime() ?? null,
    kunngjoringsdato: e.kunngjoringsdato?.getTime() ?? null,
    opprinneligAdmomrKode: e.opprinneligAdmomrKode ?? null,
    opprinneligPlanId: e.opprinneligPlanId ?? null,
    planbestemmelser: e.planbestemmelser ? 1 : 0
  };
}
function Ln(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...R(e)
  };
}
function se(e) {
  const n = e;
  return n && n.type === "coded-value" && Array.isArray(n.codedValues) ? n.codedValues : null;
}
function z(e, n) {
  const r = new Map(e.map((l) => [l.name, l])), a = {};
  for (const l of n) {
    const d = se(r.get(l)?.domain);
    a[l] = d ? d.map((t) => ({ code: String(t.code), label: t.name })) : [];
  }
  return a;
}
function le(e) {
  return z(e, G);
}
function ie(e) {
  return e.replace(/'/g, "''");
}
function h(e) {
  return `'${ie(e)}'`;
}
function On(e, n) {
  return n.length === 0 ? "1=0" : `${e} IN (${n.map(h).join(",")})`;
}
const de = W("planregister:queryTablePaged"), ue = 2e3, ce = 1e3;
async function C(e, n, r) {
  const a = {
    where: n.where,
    outFields: n.outFields ? n.outFields.join(",") : "*",
    returnGeometry: n.returnGeometry === !0,
    f: "json"
  };
  n.orderByFields && (a.orderByFields = n.orderByFields);
  const l = [];
  let d = 0;
  try {
    for (let t = 0; t < ce; t++) {
      const s = (await Y(`${e}/query`, {
        query: { ...a, resultOffset: d, resultRecordCount: ue },
        method: "post",
        responseType: "json",
        signal: r?.signal
      })).data, i = s?.features ?? [];
      for (const m of i)
        l.push(
          m.geometry ? { attributes: m.attributes, geometry: { ...m.geometry, spatialReference: s.spatialReference } } : { attributes: m.attributes }
        );
      if (s?.exceededTransferLimit !== !0 || i.length === 0)
        break;
      d += i.length;
    }
  } catch (t) {
    throw r?.signal?.aborted || pe(t) ? new J() : (de.error(`Feil ved query mot ${e}:`, t), new j(`Query mot ${e} feilet: ${t?.message ?? t}`, t));
  }
  return l;
}
async function P(e, n, r) {
  return (await C(e, n, r)).map((l) => l.attributes);
}
function pe(e) {
  return typeof e != "object" || e === null ? !1 : e.name === "AbortError";
}
function me(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await P(e, { where: t }, o)).map(oe);
  return {
    findAll: (t) => d("1=1", t),
    findByNapId: async (t, o) => (await d(`nasjonalArealplanId = ${h(t)}`, o))[0] ?? null,
    search: (t, o) => {
      const s = h(`%${t}%`);
      return d(
        `LOWER(plannavn) LIKE LOWER(${s}) OR nasjonalArealplanId LIKE ${s} OR planId LIKE ${s}`,
        o
      );
    },
    add: async (t) => l(async () => {
      const o = new g({ attributes: R(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Arealplan", m);
      return f[0];
    }, "ArealplanRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...R(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Arealplan", t.objectId);
      return i[0];
    }, "ArealplanRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "ArealplanRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), le(t.fields);
    }, "ArealplanRepository.getDomains")
  };
}
function q(e) {
  if (e != null)
    return new Date(e);
}
function fe(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: q(e.dato),
    fradato: q(e.fradato),
    tildato: q(e.tildato),
    saksnummer: e.saksnummer,
    beskrivelse: e.beskrivelse
  };
}
function $(e) {
  return {
    planbehUid: e.planbehUid,
    nasjonalArealplanId: e.nasjonalArealplanId,
    navn: e.navn,
    planbehandlingtype: e.planbehandlingtype,
    dato: e.dato?.getTime() ?? null,
    fradato: e.fradato?.getTime() ?? null,
    tildato: e.tildato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
function xn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...$(e)
  };
}
function ge(e) {
  return z(e, V);
}
function ye(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await P(e, { where: t }, o)).map(fe);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${h(t)}`, o),
    findByUid: async (t, o) => (await d(`planbehUid = ${h(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({ attributes: $(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Planbehandling", m);
      return f[0];
    }, "PlanbehandlingRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...$(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Planbehandling", t.objectId);
      return i[0];
    }, "PlanbehandlingRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanbehandlingRepository.delete"),
    getDomains: () => l(async () => {
      const t = a();
      return await t.load(), ge(t.fields);
    }, "PlanbehandlingRepository.getDomains")
  };
}
function be(e) {
  if (e != null)
    return new Date(e);
}
function he(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    planbehUid: e.planbehUid,
    dispensasjonId: e.dispensasjonId,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype,
    dokumentstatus: e.dokumentstatus,
    arkivreferanse: e.arkivreferanse,
    arkivnavn: e.arkivnavn,
    dokumentdato: be(e.dokumentdato),
    saksnummer: e.saksnummer,
    mimetype: e.mimetype,
    referansedokumentfil: e.referansedokumentfil,
    filnavn: e.filnavn,
    beskrivelse: e.beskrivelse
  };
}
function Ie(e) {
  return {
    dokumentId: e.dokumentId,
    nasjonalArealplanId: e.nasjonalArealplanId ?? null,
    planbehUid: e.planbehUid ?? null,
    dispensasjonId: e.dispensasjonId ?? null,
    tittel: e.tittel,
    dokumenttype: e.dokumenttype ?? null,
    dokumentstatus: e.dokumentstatus ?? null,
    arkivreferanse: e.arkivreferanse ?? null,
    arkivnavn: e.arkivnavn ?? null,
    dokumentdato: e.dokumentdato?.getTime() ?? null,
    saksnummer: e.saksnummer ?? null,
    mimetype: e.mimetype ?? null,
    referansedokumentfil: e.referansedokumentfil ?? null,
    filnavn: e.filnavn ?? null,
    beskrivelse: e.beskrivelse ?? null
  };
}
function ke(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await P(e, { where: t }, o)).map(he);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${h(t)}`, o),
    findForBehandling: (t, o) => d(`planbehUid = ${h(t)}`, o),
    findForDispensasjon: (t, o) => d(`dispensasjonId = ${h(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: Ie(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Plandokument", m);
      return f[0];
    }, "PlandokumentRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlandokumentRepository.delete")
  };
}
function je(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle,
    organisasjon: e.organisasjon,
    kontaktperson: e.kontaktperson
  };
}
function K(e) {
  return {
    aktorId: e.aktorId,
    planbehUid: e.planbehUid,
    rolle: e.rolle ?? null,
    organisasjon: e.organisasjon ?? null,
    kontaktperson: e.kontaktperson ?? null
  };
}
function Sn(e) {
  return {
    OBJECTID: e.objectId,
    GlobalID: e.globalId,
    ...K(e)
  };
}
function ve(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await P(e, { where: t }, o)).map(je);
  return {
    findForBehandling: (t, o) => d(`planbehUid = ${h(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: K(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Aktor", m);
      return f[0];
    }, "AktorRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t.objectId, ...K(t) } }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Aktor", t.objectId);
      return i[0];
    }, "AktorRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "AktorRepository.delete")
  };
}
function we(e) {
  if (e != null)
    return new Date(e);
}
function Fe(e) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: we(e.vedtakEndeligPlanDato),
    begrunnelse: e.begrunnelse
  };
}
function Ae(e) {
  return {
    relasjonId: e.relasjonId,
    nasjonalArealplanIdFra: e.nasjonalArealplanIdFra,
    nasjonalArealplanIdTil: e.nasjonalArealplanIdTil,
    forholdtype: e.forholdtype,
    vedtakEndeligPlanDato: e.vedtakEndeligPlanDato?.getTime() ?? null,
    begrunnelse: e.begrunnelse ?? null
  };
}
function Pe(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await P(e, { where: t }, o)).map(Fe);
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanIdFra = ${h(t)} OR nasjonalArealplanIdTil = ${h(t)}`, o),
    add: async (t) => l(async () => {
      const o = new g({ attributes: Ae(t) }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Planforhold", m);
      return f[0];
    }, "PlanforholdRepository.add"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "PlanforholdRepository.delete")
  };
}
function O(e) {
  if (e != null)
    return new Date(e);
}
function Ee(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer,
    planidentifikasjon: e.planidentifikasjon,
    dispensasjonType: e.dispensasjonType,
    dispensasjonFra: e.dispensasjonFra,
    begrunnelse: e.begrunnelse,
    vedtaksdato: new Date(e.vedtaksdato),
    vertikalnivaa: e.vertikalnivaa,
    beskrivelse: e.beskrivelse,
    innvilgetDispensasjon: !!e.innvilgetDispensasjon,
    varigDispensasjon: !!e.varigDispensasjon,
    varighetFra: O(e.varighetFra),
    varighetTil: O(e.varighetTil),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    geometry: n
  };
}
function x(e) {
  return {
    dispensasjonId: e.dispensasjonId,
    nasjonalArealplanId: e.nasjonalArealplanId,
    kommunenummer: e.kommunenummer ?? null,
    planidentifikasjon: e.planidentifikasjon ?? null,
    dispensasjonType: e.dispensasjonType ?? null,
    dispensasjonFra: e.dispensasjonFra ?? null,
    begrunnelse: e.begrunnelse ?? null,
    vedtaksdato: e.vedtaksdato.getTime(),
    vertikalnivaa: e.vertikalnivaa ?? null,
    beskrivelse: e.beskrivelse ?? null,
    innvilgetDispensasjon: e.innvilgetDispensasjon ? 1 : 0,
    varigDispensasjon: e.varigDispensasjon ? 1 : 0,
    varighetFra: e.varighetFra?.getTime() ?? null,
    varighetTil: e.varighetTil?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null
  };
}
function De(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await C(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => Ee(i.attributes, i.geometry ? Z.fromJSON(i.geometry) : void 0)
  );
  return {
    findForPlan: (t, o) => d(`nasjonalArealplanId = ${h(t)}`, o),
    findByDispensasjonId: async (t, o) => (await d(`dispensasjonId = ${h(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: x(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("Dispensasjon", m);
      return f[0];
    }, "DispensasjonRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...x(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("Dispensasjon", t.objectId);
      return i[0];
    }, "DispensasjonRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "DispensasjonRepository.delete")
  };
}
function S(e) {
  if (e != null)
    return new Date(e);
}
function Be(e, n) {
  return {
    objectId: e.OBJECTID,
    globalId: e.GlobalID,
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn,
    avgjdato: S(e.avgjdato),
    gyldigtildato: S(e.gyldigtildato),
    sakssekvensnummer: e.saksnummer__sakssekvensnummer,
    saksaar: e.saksnummer__saksaar,
    informasjon: e.informasjon,
    geometry: n
  };
}
function N(e) {
  return {
    forbudId: e.forbudId,
    kommunenummer: e.kommunenummer ?? null,
    forbudtype: e.forbudtype,
    omraadenavn: e.omraadenavn ?? null,
    avgjdato: e.avgjdato?.getTime() ?? null,
    gyldigtildato: e.gyldigtildato?.getTime() ?? null,
    saksnummer__sakssekvensnummer: e.sakssekvensnummer ?? null,
    saksnummer__saksaar: e.saksaar ?? null,
    informasjon: e.informasjon ?? null
  };
}
function Te(e, n) {
  let r = null;
  const a = () => (r ?? (r = new w({ url: e, ...n ? { token: n() ?? void 0 } : {} })), r), l = async (t, o) => {
    try {
      return await t();
    } catch (s) {
      throw s instanceof Error && s.name === "AbortError" ? s : new j(`${o} feilet: ${s?.message ?? s}`, s);
    }
  }, d = async (t, o) => (await C(e, { where: t, returnGeometry: !0 }, o)).map(
    (i) => Be(i.attributes, i.geometry ? X.fromJSON(i.geometry) : void 0)
  );
  return {
    findForKommune: (t, o) => d(`kommunenummer = ${h(t)}`, o),
    findByForbudId: async (t, o) => (await d(`forbudId = ${h(t)}`, o))[0] ?? null,
    add: async (t) => l(async () => {
      const o = new g({
        attributes: N(t),
        geometry: t.geometry
      }), i = (await a().applyEdits({ addFeatures: [o] })).addFeatureResults[0];
      if (i.error)
        throw new Error(i.error.message);
      const m = i.objectId, f = await d(`OBJECTID = ${m}`);
      if (!f[0])
        throw new I("MidlertidigForbud", m);
      return f[0];
    }, "MidlertidigForbudRepository.add"),
    update: async (t) => l(async () => {
      const o = new g({
        attributes: { OBJECTID: t.objectId, ...N(t) },
        geometry: t.geometry
      }), s = await a().applyEdits({ updateFeatures: [o] });
      if (s.updateFeatureResults[0].error)
        throw new Error(s.updateFeatureResults[0].error.message);
      const i = await d(`OBJECTID = ${t.objectId}`);
      if (!i[0])
        throw new I("MidlertidigForbud", t.objectId);
      return i[0];
    }, "MidlertidigForbudRepository.update"),
    delete: async (t) => l(async () => {
      const o = new g({ attributes: { OBJECTID: t } });
      await a().applyEdits({ deleteFeatures: [o] });
    }, "MidlertidigForbudRepository.delete")
  };
}
const qe = 0, Re = 1, $e = 2, Ke = 3, _e = 4, Ce = 5, Le = 6;
function Nn(e) {
  const n = e.serviceUrl.replace(/\/$/, ""), r = (l) => `${n}/${l}`, { getToken: a } = e;
  return {
    arealplaner: me(r($e), a),
    behandlinger: ye(r(Ke), a),
    dokumenter: ke(r(_e), a),
    aktorer: ve(r(Ce), a),
    planforhold: Pe(r(Le), a),
    dispensasjoner: De(r(qe), a),
    midlertidigeForbud: Te(r(Re), a)
  };
}
const u = {
  all: ["planregister"],
  arealplaner: {
    all: ["planregister", "arealplaner"],
    search: (e) => ["planregister", "arealplaner", "search", e],
    byNapId: (e) => ["planregister", "arealplaner", e],
    domains: ["planregister", "arealplaner", "domains"]
  },
  behandlinger: {
    all: ["planregister", "behandlinger"],
    forPlan: (e) => ["planregister", "behandlinger", e],
    byUid: (e) => ["planregister", "behandlinger", "uid", e],
    domains: ["planregister", "behandlinger", "domains"]
  },
  dokumenter: {
    all: ["planregister", "dokumenter"],
    forPlan: (e) => ["planregister", "dokumenter", "plan", e],
    forBehandling: (e) => ["planregister", "dokumenter", "behandling", e],
    forDispensasjon: (e) => ["planregister", "dokumenter", "dispensasjon", e]
  },
  aktorer: {
    all: ["planregister", "aktorer"],
    forBehandling: (e) => ["planregister", "aktorer", e]
  },
  planforhold: {
    all: ["planregister", "planforhold"],
    forPlan: (e) => ["planregister", "planforhold", e]
  },
  dispensasjoner: {
    all: ["planregister", "dispensasjoner"],
    forPlan: (e) => ["planregister", "dispensasjoner", e],
    byId: (e) => ["planregister", "dispensasjoner", "id", e]
  },
  midlertidigeForbud: {
    all: ["planregister", "midlertidigeForbud"],
    forKommune: (e) => ["planregister", "midlertidigeForbud", e],
    byId: (e) => ["planregister", "midlertidigeForbud", "id", e]
  }
}, Oe = ["10", "11", "13", "20", "21", "34", "35", "30", "31"], xe = ["1", "2", "3", "4", "5", "6", "7", "8"], Se = ["PBL2008", "PBL1985", "BL1965"], Ne = ["1", "2", "3", "4", "9"], D = (e) => ({ errorMap: () => ({ message: e }) }), Ue = p.object({
  plannavn: p.string().trim().min(1, "Plannavn er påkrevd").max(250, "Plannavn er for langt"),
  plantype: p.enum(Oe, D("Velg en gyldig plantype")),
  planstatus: p.enum(xe, D("Velg en gyldig planstatus")).optional(),
  lovreferanse: p.enum(Se, D("Velg en gyldig lovreferanse")),
  saksnummer: p.string().trim().min(1, "Saksnummer er påkrevd"),
  admomrkode: p.string().trim().min(1, "Kommunenummer er påkrevd").regex(/^\d{1,4}$/, "Kommunenummer må være inntil 4 siffer"),
  planId: p.string().trim().min(1, "PlanID er påkrevd"),
  saksaar: p.number().int().optional(),
  sakssekvensnr: p.number().int().optional(),
  forslagsstillerType: p.enum(Ne, D("Velg en gyldig forslagsstillertype")).optional(),
  ubehandletKlage: p.boolean().optional(),
  ubehandletInnsigelse: p.boolean().optional(),
  vedtaksdato: p.date().optional(),
  vedtakEndeligPlanDato: p.date().optional(),
  ikrafttredelsesdato: p.date().optional(),
  kunngjoringsdato: p.date().optional(),
  opprinneligAdmomrKode: p.string().trim().optional(),
  opprinneligPlanId: p.string().trim().optional(),
  planbestemmelser: p.boolean().optional()
}), Je = p.object({
  planbehUid: p.string().trim().min(1, "planbehUid er påkrevd"),
  nasjonalArealplanId: p.string().trim().min(1, "nasjonalArealplanId er påkrevd"),
  navn: p.string().trim().min(1, "Navn er påkrevd").max(250, "Navn er for langt"),
  planbehandlingtype: p.string().trim().min(1, "Velg behandlingstype"),
  dato: p.date({ required_error: "Dato er påkrevd", invalid_type_error: "Ugyldig dato" }),
  fradato: p.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  tildato: p.date({ invalid_type_error: "Ugyldig dato" }).optional(),
  saksnummer: p.string().trim().max(50, "Saksnummer er for langt").optional(),
  beskrivelse: p.string().trim().max(2e3, "Beskrivelsen er for lang").optional()
}).superRefine((e, n) => {
  e.fradato && e.tildato && e.tildato < e.fradato && n.addIssue({
    code: p.ZodIssueCode.custom,
    path: ["tildato"],
    message: "Til-dato kan ikke være før fra-dato"
  });
});
async function Me(e, n) {
  return e.arealplaner.findAll(n);
}
async function Qe(e, n, r) {
  return e.arealplaner.findByNapId(n, r);
}
async function Ge(e, n, r) {
  return e.arealplaner.search(n, r);
}
async function Ve(e, n, r) {
  const a = Ue.safeParse(n);
  if (!a.success) {
    const { message: i, path: m } = a.error.issues[0], f = m.join(".");
    throw new B(f ? `${f}: ${i}` : i, a.error);
  }
  const l = a.data, d = _(l.admomrkode), t = Q(d, l.planId);
  if (await e.arealplaner.findByNapId(t, r))
    throw new B(
      `Plan-ID «${l.planId.trim()}» finnes allerede i kommune ${d} (${t}).`
    );
  const s = {
    ...l,
    admomrkode: d,
    planId: l.planId.trim(),
    nasjonalArealplanId: t,
    planstatus: l.planstatus ?? M,
    ubehandletKlage: l.ubehandletKlage ?? !1,
    ubehandletInnsigelse: l.ubehandletInnsigelse ?? !1,
    planbestemmelser: l.planbestemmelser ?? !1
  };
  return e.arealplaner.add(s);
}
async function ze(e, n) {
  return e.arealplaner.getDomains(n);
}
async function He(e, n) {
  return e.arealplaner.update(n);
}
async function Ye(e, n) {
  return e.arealplaner.delete(n);
}
async function We(e, n) {
  return e.behandlinger.getDomains(n);
}
async function Ze(e, n, r) {
  return e.behandlinger.findForPlan(n, r);
}
async function Un(e, n, r) {
  return e.behandlinger.findByUid(n, r);
}
function H(e) {
  const n = Je.safeParse(e);
  if (!n.success) {
    const { message: a, path: l } = n.error.issues[0], d = l.join(".");
    throw new B(d ? `${d}: ${a}` : a, n.error);
  }
  const r = n.data;
  return {
    ...r,
    saksnummer: r.saksnummer || void 0,
    beskrivelse: r.beskrivelse || void 0
  };
}
async function Xe(e, n) {
  return e.behandlinger.add(H(n));
}
async function en(e, n) {
  const { objectId: r, globalId: a, ...l } = n;
  return e.behandlinger.update({ objectId: r, globalId: a, ...H(l) });
}
async function nn(e, n) {
  return e.behandlinger.delete(n);
}
async function rn(e, n, r) {
  return e.dokumenter.findForPlan(n, r);
}
async function tn(e, n, r) {
  return e.dokumenter.findForBehandling(n, r);
}
async function an(e, n, r) {
  return e.dokumenter.findForDispensasjon(n, r);
}
async function on(e, n) {
  return e.dokumenter.add(n);
}
async function sn(e, n) {
  return e.dokumenter.delete(n);
}
async function ln(e, n, r) {
  return e.aktorer.findForBehandling(n, r);
}
async function dn(e, n) {
  return e.aktorer.add(n);
}
async function un(e, n) {
  return e.aktorer.update(n);
}
async function cn(e, n) {
  return e.aktorer.delete(n);
}
async function pn(e, n, r) {
  return e.planforhold.findForPlan(n, r);
}
async function mn(e, n) {
  return e.planforhold.add(n);
}
async function fn(e, n) {
  return e.planforhold.delete(n);
}
async function gn(e, n, r) {
  return e.dispensasjoner.findForPlan(n, r);
}
async function Jn(e, n, r) {
  return e.dispensasjoner.findByDispensasjonId(n, r);
}
async function yn(e, n) {
  return e.dispensasjoner.add(n);
}
async function bn(e, n) {
  return e.dispensasjoner.update(n);
}
async function hn(e, n) {
  return e.dispensasjoner.delete(n);
}
async function In(e, n, r) {
  return e.midlertidigeForbud.findForKommune(n, r);
}
async function Mn(e, n, r) {
  return e.midlertidigeForbud.findByForbudId(n, r);
}
async function kn(e, n) {
  return e.midlertidigeForbud.add(n);
}
async function jn(e, n) {
  return e.midlertidigeForbud.update(n);
}
async function vn(e, n) {
  return e.midlertidigeForbud.delete(n);
}
const L = ne(null);
function Qn({ client: e, children: n }) {
  return /* @__PURE__ */ ee(L.Provider, { value: e, children: n });
}
function c() {
  const e = U(L);
  if (!e)
    throw new Error("usePlanregisterClient must be used inside <PlanregisterClientProvider>");
  return e;
}
function Gn() {
  return U(L);
}
function Vn() {
  const e = c();
  return k({
    queryKey: u.arealplaner.all,
    queryFn: ({ signal: n }) => Me(e, { signal: n })
  });
}
function zn(e) {
  const n = c();
  return k({
    queryKey: u.arealplaner.search(e),
    queryFn: ({ signal: r }) => Ge(n, e, { signal: r }),
    enabled: e.length > 0
  });
}
function Hn(e) {
  const n = c();
  return k({
    queryKey: u.arealplaner.byNapId(e ?? ""),
    queryFn: ({ signal: r }) => Qe(n, e, { signal: r }),
    enabled: !!e
  });
}
function Yn() {
  const e = c();
  return k({
    queryKey: u.arealplaner.domains,
    queryFn: ({ signal: n }) => ze(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function Wn() {
  const e = c(), n = y();
  return b({
    mutationFn: (r) => Ve(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: u.arealplaner.all })
  });
}
function Zn() {
  const e = c(), n = y();
  return b({
    mutationFn: (r) => He(e, r),
    onSuccess: (r) => {
      n.invalidateQueries({ queryKey: u.arealplaner.all }), n.invalidateQueries({ queryKey: u.arealplaner.byNapId(r.nasjonalArealplanId) });
    }
  });
}
function Xn() {
  const e = c(), n = y();
  return b({
    mutationFn: (r) => Ye(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: u.arealplaner.all })
  });
}
function er() {
  const e = c();
  return k({
    queryKey: u.behandlinger.domains,
    queryFn: ({ signal: n }) => We(e, { signal: n }),
    staleTime: 1 / 0
  });
}
function nr(e) {
  const n = c();
  return k({
    queryKey: u.behandlinger.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => Ze(n, e, { signal: r }),
    enabled: !!e
  });
}
function rr() {
  const e = c(), n = y();
  return b({
    mutationFn: (r) => Xe(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: u.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function tr() {
  const e = c(), n = y();
  return b({
    mutationFn: (r) => en(e, r),
    onSuccess: (r) => n.invalidateQueries({ queryKey: u.behandlinger.forPlan(r.nasjonalArealplanId) })
  });
}
function ar(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => nn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.behandlinger.forPlan(e) })
  });
}
function or(e) {
  const n = c();
  return k({
    queryKey: u.dokumenter.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => rn(n, e, { signal: r }),
    enabled: !!e
  });
}
function sr(e) {
  const n = c();
  return k({
    queryKey: u.dokumenter.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => tn(n, e, { signal: r }),
    enabled: !!e
  });
}
function lr(e) {
  const n = c();
  return k({
    queryKey: u.dokumenter.forDispensasjon(e ?? ""),
    queryFn: ({ signal: r }) => an(n, e, { signal: r }),
    enabled: !!e
  });
}
function ir() {
  const e = c(), n = y();
  return b({
    mutationFn: (r) => on(e, r),
    onSuccess: (r) => {
      r.nasjonalArealplanId && n.invalidateQueries({ queryKey: u.dokumenter.forPlan(r.nasjonalArealplanId) }), r.planbehUid && n.invalidateQueries({ queryKey: u.dokumenter.forBehandling(r.planbehUid) });
    }
  });
}
function dr() {
  const e = c(), n = y();
  return b({
    mutationFn: (r) => sn(e, r),
    onSuccess: () => n.invalidateQueries({ queryKey: u.dokumenter.all })
  });
}
function ur(e) {
  const n = c();
  return k({
    queryKey: u.aktorer.forBehandling(e ?? ""),
    queryFn: ({ signal: r }) => ln(n, e, { signal: r }),
    enabled: !!e
  });
}
function cr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => dn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.aktorer.forBehandling(e) })
  });
}
function pr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => un(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.aktorer.forBehandling(e) })
  });
}
function mr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => cn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.aktorer.forBehandling(e) })
  });
}
function fr(e) {
  const n = c();
  return k({
    queryKey: u.planforhold.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => pn(n, e, { signal: r }),
    enabled: !!e
  });
}
function gr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => mn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.planforhold.forPlan(e) })
  });
}
function yr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => fn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.planforhold.forPlan(e) })
  });
}
function br(e) {
  const n = c();
  return k({
    queryKey: u.dispensasjoner.forPlan(e ?? ""),
    queryFn: ({ signal: r }) => gn(n, e, { signal: r }),
    enabled: !!e
  });
}
function hr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => yn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.dispensasjoner.forPlan(e) })
  });
}
function Ir(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => bn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.dispensasjoner.forPlan(e) })
  });
}
function kr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => hn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.dispensasjoner.forPlan(e) })
  });
}
function jr(e) {
  const n = c();
  return k({
    queryKey: u.midlertidigeForbud.forKommune(e ?? ""),
    queryFn: ({ signal: r }) => In(n, e, { signal: r }),
    enabled: !!e
  });
}
function vr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => kn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.midlertidigeForbud.forKommune(e) })
  });
}
function wr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => jn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.midlertidigeForbud.forKommune(e) })
  });
}
function Fr(e) {
  const n = c(), r = y();
  return b({
    mutationFn: (a) => vn(n, a),
    onSuccess: () => r.invalidateQueries({ queryKey: u.midlertidigeForbud.forKommune(e) })
  });
}
const wn = {
  plantype: [
    { code: "10", label: "Fylkesplan" },
    { code: "11", label: "Fylkesdelplan" },
    { code: "13", label: "Regional plan" },
    { code: "20", label: "Kommuneplan" },
    { code: "21", label: "Kommunedelplan" },
    { code: "34", label: "Områderegulering" },
    { code: "35", label: "Detaljregulering" },
    { code: "30", label: "Reguleringsplan (pbl 1985)" },
    { code: "31", label: "Bebyggelsesplan (pbl 1985)" }
  ],
  planstatus: [
    { code: "1", label: "Planlegging igangsatt" },
    { code: "2", label: "Planforslag" },
    { code: "3", label: "Endelig vedtatt" },
    { code: "4", label: "Opphevet" },
    { code: "5", label: "Utgått/erstattet" },
    { code: "6", label: "Vedtatt med utsatt rettsvirkning" },
    { code: "7", label: "Endelig vedtatt med tidsbegrensning" },
    { code: "8", label: "Overstyrt" }
  ],
  lovreferanse: [
    { code: "PBL2008", label: "Plan- og bygningsloven 2008" },
    { code: "PBL1985", label: "Plan- og bygningsloven 1985" },
    { code: "BL1965", label: "Bygningsloven 1965" }
  ],
  forslagsstillerType: [
    { code: "1", label: "Kommunen" },
    { code: "2", label: "Statlig myndighet" },
    { code: "3", label: "Fylkeskommune" },
    { code: "4", label: "Privat forslagsstiller" },
    { code: "9", label: "Annen" }
  ]
}, Fn = {
  planbehandlingtype: [
    { code: "A", label: "Testbehandling A" },
    { code: "B", label: "Testbehandling B" },
    { code: "C", label: "Testbehandling C" }
  ]
};
let An = 1;
const v = () => An++, F = () => `{${v().toString().padStart(8, "0")}-0000-0000-0000-000000000000}`;
class Ar {
  constructor() {
    this.store = [];
  }
  findAll(n) {
    return Promise.resolve([...this.store]);
  }
  findByNapId(n, r) {
    return Promise.resolve(this.store.find((a) => a.nasjonalArealplanId === n) ?? null);
  }
  search(n, r) {
    const a = n.toLowerCase();
    return Promise.resolve(this.store.filter(
      (l) => l.plannavn?.toLowerCase().includes(a) || l.planId.includes(n) || l.nasjonalArealplanId.includes(n)
    ));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: F() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Arealplan ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(wn);
  }
}
class Pr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByUid(n, r) {
    return Promise.resolve(this.store.find((a) => a.planbehUid === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: F() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Planbehandling ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
  getDomains() {
    return Promise.resolve(Fn);
  }
}
class Er {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  findForDispensasjon(n, r) {
    return Promise.resolve(this.store.filter((a) => a.dispensasjonId === n));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: F() };
    return this.store.push(r), Promise.resolve(r);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Dr {
  constructor() {
    this.store = [];
  }
  findForBehandling(n, r) {
    return Promise.resolve(this.store.filter((a) => a.planbehUid === n));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: F() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Aktor ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Br {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter(
      (a) => a.nasjonalArealplanIdFra === n || a.nasjonalArealplanIdTil === n
    ));
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: F() };
    return this.store.push(r), Promise.resolve(r);
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class Tr {
  constructor() {
    this.store = [];
  }
  findForPlan(n, r) {
    return Promise.resolve(this.store.filter((a) => a.nasjonalArealplanId === n));
  }
  findByDispensasjonId(n, r) {
    return Promise.resolve(this.store.find((a) => a.dispensasjonId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: F() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`Dispensasjon ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
class qr {
  constructor() {
    this.store = [];
  }
  findForKommune(n, r) {
    return Promise.resolve(this.store.filter((a) => a.kommunenummer === n));
  }
  findByForbudId(n, r) {
    return Promise.resolve(this.store.find((a) => a.forbudId === n) ?? null);
  }
  add(n) {
    const r = { ...n, objectId: v(), globalId: F() };
    return this.store.push(r), Promise.resolve(r);
  }
  update(n) {
    const r = this.store.findIndex((a) => a.objectId === n.objectId);
    return r === -1 ? Promise.reject(new Error(`MidlertidigForbud ${n.objectId} not found`)) : (this.store[r] = n, Promise.resolve(n));
  }
  delete(n) {
    const r = this.store.findIndex((a) => a.objectId === n);
    return r !== -1 && this.store.splice(r, 1), Promise.resolve();
  }
}
export {
  J as AbortedError,
  re as AuthError,
  G as CODELIST_FIELDS,
  M as DEFAULT_PLANSTATUS,
  wn as FAKE_AREALPLAN_DOMAINS,
  Fn as FAKE_PLANBEHANDLING_DOMAINS,
  Ne as FORSLAGSSTILLER_VALUES,
  Dr as FakeAktorRepository,
  Ar as FakeArealplanRepository,
  Tr as FakeDispensasjonRepository,
  qr as FakeMidlertidigForbudRepository,
  Pr as FakePlanbehandlingRepository,
  Er as FakePlandokumentRepository,
  Br as FakePlanforholdRepository,
  Se as LOVREFERANSE_VALUES,
  j as NetworkError,
  I as NotFoundError,
  V as PLANBEHANDLING_CODELIST_FIELDS,
  xe as PLANSTATUS_VALUES,
  Oe as PLANTYPE_VALUES,
  Qn as PlanregisterClientProvider,
  A as PlanregisterError,
  B as ValidationError,
  je as aktorFromAttrs,
  K as aktorInputToAttrs,
  Sn as aktorToAttrs,
  oe as arealplanFromAttrs,
  Ue as arealplanInputSchema,
  R as arealplanInputToAttrs,
  Ln as arealplanToAttrs,
  le as buildArealplanDomains,
  z as buildDomains,
  On as buildInClause,
  ge as buildPlanbehandlingDomains,
  dn as createAktor,
  ve as createArcgisAktorRepository,
  me as createArcgisArealplanRepository,
  De as createArcgisDispensasjonRepository,
  Te as createArcgisMidlertidigForbudRepository,
  ye as createArcgisPlanbehandlingRepository,
  ke as createArcgisPlandokumentRepository,
  Pe as createArcgisPlanforholdRepository,
  Ve as createArealplan,
  yn as createDispensasjon,
  kn as createMidlertidigForbud,
  Xe as createPlanbehandling,
  on as createPlandokument,
  mn as createPlanforhold,
  Nn as createPlanregisterClient,
  cn as deleteAktor,
  Ye as deleteArealplan,
  hn as deleteDispensasjon,
  vn as deleteMidlertidigForbud,
  nn as deletePlanbehandling,
  sn as deletePlandokument,
  fn as deletePlanforhold,
  Q as deriveNasjonalArealplanId,
  Ee as dispensasjonFromAttrs,
  x as dispensasjonInputToAttrs,
  Cn as domain,
  te as domainLabel,
  ae as domainOptions,
  ie as escapeSqlValue,
  Me as findAllArealplaner,
  Qe as findArealplanByNapId,
  Un as findBehandlingByUid,
  Jn as findDispensasjonById,
  Mn as findMidlertidigForbudById,
  ln as loadAktorerForBehandling,
  ze as loadArealplanDomains,
  Ze as loadBehandlingerForPlan,
  gn as loadDispensasjonerForPlan,
  tn as loadDokumenterForBehandling,
  an as loadDokumenterForDispensasjon,
  rn as loadDokumenterForPlan,
  In as loadMidlertidigForbudForKommune,
  We as loadPlanbehandlingDomains,
  pn as loadPlanforholdForPlan,
  Be as midlertidigForbudFromAttrs,
  N as midlertidigForbudInputToAttrs,
  _ as normalizeAdmomrkode,
  fe as planbehandlingFromAttrs,
  Je as planbehandlingInputSchema,
  $ as planbehandlingInputToAttrs,
  xn as planbehandlingToAttrs,
  he as plandokumentFromAttrs,
  Ie as plandokumentInputToAttrs,
  Fe as planforholdFromAttrs,
  Ae as planforholdInputToAttrs,
  u as planregisterKeys,
  C as queryFeaturesPaged,
  P as queryTablePaged,
  h as qv,
  Ge as searchArealplaner,
  un as updateAktor,
  He as updateArealplan,
  bn as updateDispensasjon,
  jn as updateMidlertidigForbud,
  en as updatePlanbehandling,
  ur as useAktorer,
  Hn as useArealplan,
  Yn as useArealplanDomains,
  Vn as useArealplaner,
  zn as useArealplanerSearch,
  cr as useCreateAktor,
  Wn as useCreateArealplan,
  hr as useCreateDispensasjon,
  vr as useCreateMidlertidigForbud,
  rr as useCreatePlanbehandling,
  ir as useCreatePlandokument,
  gr as useCreatePlanforhold,
  mr as useDeleteAktor,
  Xn as useDeleteArealplan,
  kr as useDeleteDispensasjon,
  Fr as useDeleteMidlertidigForbud,
  ar as useDeletePlanbehandling,
  dr as useDeletePlandokument,
  yr as useDeletePlanforhold,
  br as useDispensasjoner,
  jr as useMidlertidigeForbud,
  er as usePlanbehandlingDomains,
  nr as usePlanbehandlinger,
  sr as usePlandokumenterForBehandling,
  lr as usePlandokumenterForDispensasjon,
  or as usePlandokumenterForPlan,
  fr as usePlanforhold,
  c as usePlanregisterClient,
  Gn as usePlanregisterClientOptional,
  pr as useUpdateAktor,
  Zn as useUpdateArealplan,
  Ir as useUpdateDispensasjon,
  wr as useUpdateMidlertidigForbud,
  tr as useUpdatePlanbehandling
};
//# sourceMappingURL=index.mjs.map
